import MySeachOption from './seachOption.vue';

MySeachOption.install = function(Vue){
  Vue.component('MySeachOption', MySeachOption);
};

export default MySeachOption;